import { useState } from "react";
import SignInForm from "./SignInForm.jsx";
import SignupForm from "./SignupForm.jsx";
import ResetPasswordForm from "./ResetPasswordForm.jsx";
import LoginFlow from "@/layouts/LoginFlow.jsx";

export default function AuthScreen() {
    const [mode, setMode] = useState("signin"); // "signin", "signup", "reset"

    return (
        <LoginFlow>
            <div className="w-full max-w-xs">
                {mode === "signin" && (
                    <>
                        <SignInForm />
                        <div className="text-center text-sm text-muted-foreground space-y-2">
                            <p>
                                Forgot your password?{" "}
                                <button
                                    onClick={() => setMode("reset")}
                                    className="text-brand underline"
                                >
                                    Reset it
                                </button>
                            </p>
                            <p>
                                Don't have an account?{" "}
                                <button
                                    onClick={() => setMode("signup")}
                                    className="text-brand underline"
                                >
                                    Sign up
                                </button>
                            </p>
                        </div>
                    </>
                )}

                {mode === "signup" && (
                    <>
                        <SignupForm />
                        <div className="text-center text-sm text-muted-foreground">
                            Already have an account?{" "}
                            <button
                                onClick={() => setMode("signin")}
                                className="text-brand underline"
                            >
                                Sign in
                            </button>
                        </div>
                    </>
                )}

                {mode === "reset" && (
                    <>
                        <ResetPasswordForm />
                        <div className="text-center text-sm text-muted-foreground">
                            Remembered your password?{" "}
                            <button
                                onClick={() => setMode("signin")}
                                className="text-brand underline"
                            >
                                Sign in
                            </button>
                        </div>
                    </>
                )}
            </div>
        </LoginFlow>
    );
}
